module.exports = "/lucky-balls/img/black-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/black-ball.png
// module id = 94
// module chunks = 0